import { ArrowBack } from "@mui/icons-material";
import { Alert, Button, Typography } from "@mui/material";

const ArticleTitle = ({ initialValues, id, insertData, updateData }) => {
  return (
    <>
      <Typography variant="subtitle1">
        {id < 1 && <span>Makale Ekle</span>}
        {id > 0 && <span>{initialValues?.title} Makalesini Düzenle</span>}
      </Typography>
      {insertData.data && (
        <div className="w-full flex items-center justify-between bg-[#edf7ed]">
          <Alert severity="success">Makale Ekleme İşlemi Başarılı...</Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href="/articles"
          >
            Geri Dön
          </Button>
        </div>
      )}
      {insertData.isError && (
        <div className="w-full flex items-center justify-between bg-[#edf7ed]">
          <Alert severity="error">
            Makale Ekleme Sırasında Bir Hata oluşu. Lütfen Tekrar Deneyiniz!
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href="/articles"
          >
            Geri Dön
          </Button>
        </div>
      )}
      {updateData.isSuccess && (
        <div className="w-full flex items-center justify-between bg-[#edf7ed]">
          <Alert severity="success">
            {initialValues.title} Makalesi Başarıyla Güncellendi ...
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href="/articles"
          >
            Geri Dön
          </Button>
        </div>
      )}
      {updateData.isError && (
        <div className="w-full flex items-center justify-between bg-[#edf7ed]">
          <Alert severity="error">
            {initialValues.title} Makalesi Güncellenirken Bir Hata Oluştu!
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href="/articles"
          >
            Geri Dön
          </Button>
        </div>
      )}
    </>
  );
};

export default ArticleTitle;
